import React from 'react';
import type {SerializedError} from '@reduxjs/toolkit';
import {
  type FetchBaseQueryError,
  QueryStatus,
} from '@reduxjs/toolkit/query/react';
import {ActivityIndicator} from 'components/activityIndicator';

type Props = {
  status: QueryStatus;
  error?: FetchBaseQueryError | SerializedError | undefined;
  children: React.ReactNode;
};

export const RtkContent: React.FC<Props> = ({status, error, children}) => {
  if (status === QueryStatus.uninitialized) {
    return null;
  }
  if (status === QueryStatus.pending) {
    return <ActivityIndicator />;
  }

  if (error) {
    if ('status' in error) {
      // FetchBaseQueryError
      const errMsg =
        'error' in error ? error.error : JSON.stringify(error.data);

      return (
        <div>
          <div>An error has occurred:</div>
          <div>{errMsg}</div>
        </div>
      );
    }
    // SerializedError
    return <div>{error.message}</div>;
  }

  return <>{children}</>;
};
